import React, { createContext, useContext, useEffect, useState } from "react";
import axiosInstance from "../services/axios-instance";
import { CURRENT_USER_URL } from "../services/endpoints";
import { AuthContext } from "./auth-provider";

interface ContextData {
    currentUser: CurrentUserInterface;
    setCurrentUser: React.Dispatch<React.SetStateAction<CurrentUserInterface>>;
}

interface CurrentUserInterface {
    id: number | null;
    name: string;
    email: string;
    role_id: number | null;
    profile_picture: string;
    available_days_current: number;
    available_days_left_current: number;
    available_days_prev: number;
    available_days_left_all: number;
    available_days_left_prev: number;
    available_days_next: number;
    available_days_left_next: number;
    clients: any[];
    profile_picture_focal_point: string | null;
    client_id: number | null;
}

export const DataContext = createContext({} as ContextData);

interface Props {
    children: React.ReactNode;
}

export const DataProvider: React.FC<Props> = ({ children }) => {
    const { session } = useContext(AuthContext);
    const [currentUser, setCurrentUser] = useState<CurrentUserInterface>({
        id: null,
        name: "",
        email: "",
        role_id: null,
        profile_picture: "",
        available_days_current: 0,
        available_days_left_current: 0,
        available_days_prev: 0,
        available_days_left_all: 0,
        available_days_left_prev: 0,
        available_days_next: 0,
        available_days_left_next: 0,
        clients: [],
        profile_picture_focal_point: null,
        client_id: 0
    });

    useEffect(() => {
        async function fetchData() {
            try {
                const response = await axiosInstance.get(CURRENT_USER_URL);
                setCurrentUser(response.data.data);
            } catch (error) {
                console.error(error);
            }
        }

        if (session) {
            fetchData();
        } else {
            setCurrentUser({
                id: null,
                name: "",
                email: "",
                role_id: null,
                profile_picture: "",
                available_days_current: 0,
                available_days_left_all: 0,
                available_days_left_current: 0,
                available_days_prev: 0,
                available_days_left_prev: 0,
                available_days_next: 0,
                available_days_left_next: 0,
                clients: [],
                profile_picture_focal_point : null,
                client_id: 0
            });
        }
    }, [session]);

    const contextObj: ContextData = {
        currentUser,
        setCurrentUser,
    };

    return (
        <DataContext.Provider value={contextObj}>
            {children}
        </DataContext.Provider>
    );
};
